module.exports = __webpack_public_path__ + "media/images/pages/team-3-31a4bebd59fd4a8dffd120d210b575ab.jpg";